import { InboxOutlined } from '@ant-design/icons';
import { App, AutoComplete, Checkbox, Col, Divider, Form, Input, InputNumber, Row, Select, Upload } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../../../../context/AuthProvider';
import {
  setAdditional,
  updateAdditionalWorkPlaceItem,
  updateField,
} from '../../../../../contextRedux/AdditionalAct/AdditionalActModel';
import { RootState } from '../../../../../store';

const { Option } = AutoComplete;
const { Dragger } = Upload;

const CompanyDetailsTab: React.FC<any> = ({ form, fileList, setFileList }) => {
  const dispatch = useDispatch();

  const id = useSelector((state: RootState) => state?.models?.additionalAct?.id);
  const companyId = useSelector((state: RootState) => state?.models?.additionalAct?.companyId);
  const reduxActAdditional = useSelector((state: RootState) => state?.models?.additionalAct);

  const offers = useSelector((state: RootState) => state.store.offer);
  const companies = useSelector((state: RootState) => state.store.company.data);
  const status = useSelector((state: RootState) => state?.store.statusContract.data);
  const accountSales = useSelector((state: RootState) => state?.store.user.data);

  const { profile } = useAuth();
  const { message } = App.useApp();
  const currentDate = moment().format('YYYY-MM-DD');

  const initialValues = {
    company: useSelector((state: RootState) => state?.models?.additionalAct?.company),
    companyId: useSelector((state: RootState) => state?.models?.additionalAct?.companyId),
    accountManager: useSelector((state: RootState) => state?.models?.additionalAct?.accountManager),
    accountSale: useSelector((state: RootState) => state?.models?.additionalAct?.accountSale),
    accountSaleId: useSelector((state: RootState) => state?.models?.additionalAct?.accountSaleId),
    enumContractStatus: useSelector((state: RootState) => state?.models?.additionalAct?.enumContractStatus),
    enumContractStatusId: useSelector((state: RootState) => state?.models?.additionalAct?.enumContractStatusId),
    date: useSelector((state: RootState) => state?.models?.additionalAct?.date),
    dateStart: useSelector((state: RootState) => state?.models?.additionalAct?.dateStart),
    dateEnd: useSelector((state: RootState) => state?.models?.additionalAct?.dateEnd),
    datePeriod: useSelector((state: RootState) => state?.models?.additionalAct?.datePeriod),
    acquisitionType: useSelector((state: RootState) => state?.models?.additionalAct?.acquisitionType),
    intervention: useSelector((state: RootState) => state?.models?.additionalAct?.intervention),
    hasUnlimitedInterventions: useSelector(
      (state: RootState) => state?.models?.additionalAct?.hasUnlimitedInterventions
    ),
    isExpedite: useSelector((state: RootState) => state?.models?.additionalAct?.isExpedite),
    hasAutomaticExtension: useSelector((state: RootState) => state?.models?.additionalAct?.hasAutomaticExtension),
    registrationNumber: useSelector((state: RootState) => state?.models?.additionalAct?.registrationNumber),
    remarks: useSelector((state: RootState) => state?.models?.additionalAct?.remarks),
  };

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  const handleSelectClient = (value: any) => {
    const company = companies.find((company: any) => company.name === value?.label);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      company: company,
      companyId: company?.id,
      accountManager: company?.accountManager,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
    dispatch(updateField({ field: 'company', value: company ?? null }));
    dispatch(updateField({ field: 'accountManagerId', value: company?.accountManager?.id ?? null }));
    dispatch(updateField({ field: 'accountManager', value: company?.accountManager ?? null }));
  };

  const handleSelectAccountSales = (value: string) => {
    const accountSale = accountSales?.find((date: any) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      accountSale: accountSale,
      accountSaleId: accountSale?.id,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'accountSaleId', value: accountSale?.id ?? null }));
    dispatch(updateField({ field: 'accountSale', value: accountSale ?? null }));
  };

  const handleSelectStatus = (value: string) => {
    const selectStatus = status.find((date: any) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      enumContractStatusId: selectStatus?.id,
      enumContractStatus: selectStatus,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'enumContractStatusId', value: selectStatus?.id ?? null }));
    dispatch(updateField({ field: 'enumContractStatus', value: selectStatus ?? null }));
  };

  const handleSelectClientOffer = (value: string) => {
    const offer = offers.data.find((o) => o?.number == value);
    dispatch(
      setAdditional({
        ...offer,
        id: null,
        offerId: offer?.id,
        contractLaborExtras: offer.offerLaborExtras,
        contractWorkPlaceItems: offer.offerWorkPlaceItems,
      })
    );
  };

  useEffect(() => {
    if (companyId) {
      const company = companies.find((company: any) => company.id === companyId);
      form.setFieldsValue({
        company: company,
        companyId: company?.id,
        accountManager: company?.accountManager,
      });

      dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
      dispatch(updateField({ field: 'company', value: company ?? null }));
      form.setFieldsValue({
        ...initialValues,
      });
      if (id == null || id == undefined || id == '') {
        handleSelectAccountSales(profile?.name!);
      }
    }
  }, [companyId]);

  useEffect(() => {
    if (id == null || id == undefined || id == '') {
      const currentDate = new Date().toISOString().split('T')[0];
      const oneYearLater = new Date();
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
      const formattedOneYearLater = oneYearLater.toISOString().split('T')[0];

      form.setFieldsValue({
        ...initialValues,
      });

      dispatch(updateField({ field: 'enumContractStatusId', value: 1 }));
      dispatch(updateField({ field: 'date', value: currentDate }));
      dispatch(updateField({ field: 'dateStart', value: currentDate }));
      dispatch(updateField({ field: 'dateEnd', value: formattedOneYearLater }));
      dispatch(updateField({ field: 'datePeriod', value: 30 }));
      dispatch(updateField({ field: 'acquisitionType', value: 'transfer bancar' }));
    }
  }, [id]);

  useEffect(() => {
    const uniqueSystemTypeIds = Array.from(
      new Set(
        reduxActAdditional.contractWorkPlaceItems.filter((c: any) => c.systemTypeId).map((c: any) => c.systemTypeId)
      )
    );

    dispatch(updateField({ field: 'intervention', value: uniqueSystemTypeIds.length }));
    form.setFieldValue('intervention', uniqueSystemTypeIds.length);
  }, [reduxActAdditional.contractWorkPlaceItems]);

  const onDateChange = (dateField: string, dateValue: string) => {
    dispatch(updateField({ field: dateField, value: dateValue }));
    form.setFieldsValue({ [dateField]: dateValue });

    reduxActAdditional.contractWorkPlaceItems.forEach((item: any, index: number) => {
      if (dateField == 'dateEnd') {
        dispatch(
          updateAdditionalWorkPlaceItem({
            index,
            updates: {
              ...item,
              dateEnd: dateValue, // Assuming you want to update the dateEnd field
            },
          })
        );
      }
    });
  };

  const handleBlurClear = (fieldNames: string[]) => {
    fieldNames.forEach((field) => {
      form.setFieldsValue({ [field]: null });
      dispatch(updateField({ field, value: null }));
    });
  };

  const beforeUpload = (file: any) => {
    const isPdf = file.type === 'application/pdf';
    if (!isPdf) {
      message.error('You can only upload PDF files!');
      return Upload.LIST_IGNORE;
    }
    setFileList([file]);
    return false;
  };

  const handleChangeUnlimitedInterventions = (value: boolean) => {
    dispatch(updateField({ field: 'hasUnlimitedInterventions', value: value }));
  };

  const handleRemove = () => {
    setFileList([]);
  };

  return (
    <Form form={form} onValuesChange={handleFieldChange} layout='vertical' style={{ margin: '20px 20px' }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['company', 'name']}
            label='Selectati Client'
            rules={[{ required: true, message: 'Alegeti un client!' }]}
          >
            <Select
              disabled={!!id}
              showSearch // Enables search functionality
              placeholder='Search and select a client'
              optionFilterProp='label'
              onSelect={(_value, option: any) => {
                handleSelectClient(option);
              }}
              onChange={() => handleBlurClear(['company', 'companyId'])} // Clear form fields when changed
              filterOption={(input, option) => {
                return option?.label?.toLowerCase()?.includes(input.toLowerCase());
              }}
              options={companies?.map((company) => ({
                value: company?.id,
                label: company?.name ?? '',
              }))}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['accountManager', 'name']}
            label='Manager de cont'
            rules={[{ required: true, message: 'Alegeti un manager de cont!' }]}
          >
            <Input disabled={true} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['accountSale', 'name']}
            label='Agent Vanzari'
            rules={[{ required: true, message: 'Alegeti un agent de vanzari!' }]}
          >
            <AutoComplete
              disabled={true}
              options={accountSales?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectAccountSales}
              onChange={() => handleBlurClear(['accountSale', 'accountSaleId'])}
              filterOption={(input, option: any) => option.value.toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
        </Col>
        {(id == '' || id == undefined || id == null) && (
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item name={['offer', 'number']} label='Select Offer'>
              <AutoComplete onSelect={handleSelectClientOffer} disabled={true}>
                {offers?.data?.map((offer: any, index: any) => (
                  <Option key={index} value={offer?.number}>
                    {offer?.number}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>
        )}
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item name={['enumContractStatus', 'name']} label='Status'>
            <AutoComplete
              disabled={true}
              options={status?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectStatus}
              onChange={() => handleBlurClear(['enumContractStatus', 'enumContractStatusId'])}
            />
          </Form.Item>
        </Col>
        <Divider />
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            label='Data Contract'
            name='date'
            rules={[{ required: true, message: 'Introduceti data contract!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('date', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            label='Data Inceput'
            name='dateStart'
            rules={[{ required: true, message: 'Introduceti data inceput!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('dateStart', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            label='Data Sfarsit'
            name='dateEnd'
            rules={[{ required: true, message: 'Introduceti data sfarsit!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('dateEnd', e.target.value)} />
          </Form.Item>
        </Col>
        {/* <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Perioada Ofertuala'
            name='datePeriod'
            rules={[{ required: true, message: 'Introduceti perioada ofertuala!' }]}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col> */}
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            label='Achizitie'
            name='acquisitionType'
            rules={[
              {
                required: true,
                message: 'Introduceticeti tipul de achizitie!',
              },
            ]}
          >
            <Select disabled={true}>
              <Select.Option value='numerar'>Numerar</Select.Option>
              <Select.Option value='cash'>Cash</Select.Option>
              <Select.Option value='transfer bancar'>Transfer Bancar</Select.Option>
              <Select.Option value='bilet la ordin'>Bilet la Ordin</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label='Obervatii' name='remarks'>
            <TextArea />
          </Form.Item>
        </Col>
        {!reduxActAdditional.hasUnlimitedInterventions && (
          <Col xs={24} sm={12} md={12} lg={8}>
            {(!id || !reduxActAdditional.hasUnlimitedInterventions) && (
              <Form.Item
                label='Intervenții Corective'
                name='intervention'
                initialValue={3}
                rules={[
                  {
                    required: true,
                    message: 'Introduceți numărul de intervenții corective!',
                  },
                ]}
              >
                <InputNumber disabled={!!id} style={{ width: '100%' }} />
              </Form.Item>
            )}
          </Col>
        )}
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Numar de Inregistrare'
            name='registrationNumber'
            rules={[
              {
                required: true,
                message: 'Introduceți numărul de inregistrare!',
              },
            ]}
          >
            <Input onChange={(e) => dispatch(updateField({ field: 'registrationNumber', value: e.target.value }))} />
          </Form.Item>
        </Col>

        {(!id || reduxActAdditional.hasUnlimitedInterventions) && (
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item label='Intervenții Nelimitate' name='hasUnlimitedInterventions' valuePropName='checked'>
              <Checkbox
                disabled={!!id}
                onChange={(e) => {
                  handleChangeUnlimitedInterventions(e.target.checked);
                  if (e.target.checked) {
                    form.setFieldsValue({ intervention: undefined });
                  }
                }}
              />
            </Form.Item>
          </Col>
        )}
        <Col xs={24} sm={12} md={8} lg={4}>
          <Form.Item label='Urgent' name='isExpedite' valuePropName='checked'>
            <Checkbox onChange={(e) => dispatch(updateField({ field: 'isExpedite', value: e.target.checked }))} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={4}>
          <Form.Item label='Prelungire automata' name='hasAutomaticExtension' valuePropName='checked'>
            <Checkbox
              disabled={reduxActAdditional.enumContractStatus?.id == 4}
              onChange={(e) => dispatch(updateField({ field: 'hasAutomaticExtension', value: e.target.checked }))}
            />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Dragger beforeUpload={beforeUpload} fileList={fileList} onRemove={handleRemove} multiple={false}>
            <p className='ant-upload-drag-icon'>
              <InboxOutlined />
            </p>
            <p className='ant-upload-text'>Click sau plaseaza fisierul PDF pentru incarcare</p>
            <p className='ant-upload-hint'>Doar fisiere PDF.</p>
          </Dragger>
        </Col>
      </Row>
    </Form>
  );
};

export default CompanyDetailsTab;
